import Vue from 'vue';
import { getActiveTemplate } from './index';

function toMap(context) {
    if (!context) return {};
    return context.keys().reduce((acc, key) => {
        if (key.startsWith('./')) acc['images/' + key.slice(2)] = context(key);
        return acc;
    }, {});
}

const sharedMap = toMap(require.context('@/assets/images', true, /\.(png|jpe?g|gif|svg|webp)$/));
let templateMap = null;

// Resolves an image path, preferring the active template's copy.
// Returns '' when the image does not exist.
export function findAsset(relPath) {
    if (!relPath) return '';
    if (!templateMap) templateMap = toMap(getActiveTemplate().assets);
    return templateMap[relPath] || sharedMap[relPath] || '';
}

// Same as findAsset, but warns in development when the image is missing:
// asset('images/misc/logo.png')
export function asset(relPath) {
    if (!relPath) return '';
    const url = findAsset(relPath);
    if (!url && process.env.NODE_ENV !== 'production') {
        console.warn('[asset] missing:', relPath, 'template:', getActiveTemplate().id);
    }
    return url || '';
}

Vue.prototype.$asset = asset;

export default asset;
